import $ from 'jquery';
import { $doc } from '../utils/globals';

$doc.on('click', '.js-popup-trigger', function(e) {
    e.preventDefault();
    const target = $(this).attr('href');
    $(target).addClass('is-active');
})

$doc
    .on('click', '.js-popup', (e) => {
        const $target = $(this);
        if ($target.hasClass('js-popup')) {
            $target.removeClass('is-active');
        }
    })
    .on('click', '.js-popup-close', function(e) {
        e.preventDefault();
        $(this).closest('.js-popup').removeClass('is-active');
    })

$doc.on('keydown', (event) => {
    if (event.key === 'Escape') {
        $('.js-popup.is-active').removeClass('is-active');
    }
});